import { Component, ChangeDetectionStrategy } from "@angular/core";
import { ProcessCollectionComponent } from "process/table/process-collection.component";
import { AsyncPipe, NgTemplateOutlet } from "@angular/common";
import { DescriptionViewComponent } from "common/editor/description-view.component";
import { RouterLink } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";

@Component({
	selector: "stages-process-table",
	templateUrl: "./process-table.component.html",
	styleUrls: ["./process-table.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [DescriptionViewComponent, RouterLink, NgTemplateOutlet, AsyncPipe, TranslateModule],
})
export class ProcessTableComponent extends ProcessCollectionComponent {
	columns: unknown;

	constructor() {
		super();
	}
}
